import * as z from 'zod';

import { TeamId } from '../BrandedIds';
import { User } from '../User';
import { zodBrandedUuid, zodDateOrString } from '../utils';
import { TeamPermissions } from './TeamPermissions';
import { TeamSpecialistRole } from './TeamSpecialistRole';
import { TeamTasks } from './TeamTasks';

export const Team = z.object({
  id: zodBrandedUuid<TeamId>(),
  name: z.string(),
  permissions: TeamPermissions,
  tasks: TeamTasks,
  users: User.array(),
  specialistRole: TeamSpecialistRole.optional(),

  createdAt: zodDateOrString,
  updatedAt: zodDateOrString,
  lastUpdatedBy: User,
  deletedAt: zodDateOrString.optional(),
});
export type Team = z.infer<typeof Team>;
